import { useTranslation } from 'react-i18next'
import { useMediaQuery } from 'usehooks-ts'

import { useSearchQuery } from '@features/search'


import { useCategoriesModal } from '@widgets/modal-categories/hooks/useCategoriesModal'

import { URL_MAIN_PAGE } from '@shared/contants'
import Button from '@shared/ui/button'

import styles from './styles.module.scss'

import SearchEmptyIcon from '/icons/search-empty.svg'

export default function Empty () {
  const isTablet = useMediaQuery('(max-width: 991px)')
  const searchQuery = useSearchQuery()
  const { t: ts } = useTranslation('search')
  const { t: tc } = useTranslation('common')
  const { openModal: openCategoriesModal } = useCategoriesModal()
  return (
    <div className={styles.empty}>
      <h3 className={styles.empty__title}>
        <img src={SearchEmptyIcon} alt="" />
        {ts('empty.title', {
          query: searchQuery,
        })}
      </h3>
      <p className={styles.empty__description}>{ts('empty.description')}</p>
      <div className={styles.empty__group}>
        <Button to={URL_MAIN_PAGE} size={!isTablet ? 'large' : 'medium'}>
          {tc('main.back.button')}
        </Button>
        <Button
          // to={URL_PAGE_CATALOG}
          onClick={() => openCategoriesModal()}
          size={!isTablet ? 'large' : 'medium'}
          theme="secondary"
        >
          {tc('button.catalog')}
        </Button>
      </div>
    </div>
  )
}
